export const CHANGE_PRICE_STATE = 'CHANGE_PRICE_STATE';
const changeState = bool => ({
    type: CHANGE_PRICE_STATE,
    payload: bool
});

export const changePriceState = (event) => dispatch => {
    event && dispatch(event);

    dispatch(changeState(true));
    setTimeout(() => dispatch(changeState(false)), 1000);
};

export const SELECT_RADIO = 'SELECT_RADIO';
export const selectRadio = (id, property) => dispatch => dispatch(changePriceState({
    type: SELECT_RADIO,
    payload: {
        id: Number(id),
        property
    }
}));

export const SELECT_CHECKBOX = 'SELECT_CHECKBOX';
export const selectCheckbox = (id, property) => dispatch => dispatch(changePriceState({
    type: SELECT_CHECKBOX,
    payload: {
        id: Number(id),
        property
    }
}));

export const REGISTER_COMPONENT = 'REGISTER_COMPONENT';
export const registerComponent = ({property}) => ({
    type: REGISTER_COMPONENT,
    payload: {
        property
    }
});



// WEBPACK FOOTER //
// ./src/actions/select.js